export const ShiftActionTypes = {
    LOGOUT: 'LOGOUT',

    ADD_SHIFT_REQUEST: 'ADD_SHIFT_REQUEST',
    ADD_SHIFT_REQUEST_SUCCESS: 'ADD_SHIFT_REQUEST_SUCCESS',
    ADD_SHIFT_REQUEST_ERROR: 'ADD_SHIFT_REQUEST_ERROR',
    ADD_SHIFT_REQUEST_STATUS: 'ADD_SHIFT_REQUEST_STATUS',

    SHIFT_LIST_REQUEST: 'SHIFT_LIST_REQUEST',
    SHIFT_LIST_REQUEST_SUCCESS: 'SHIFT_LIST_REQUEST_SUCCESS',
    SHIFT_LIST_REQUEST_ERROR: 'SHIFT_LIST_REQUEST_ERROR',

    SHIFT_DETAIL_REQUEST: 'SHIFT_DETAIL_REQUEST',
    SHIFT_DETAIL_REQUEST_SUCCESS: 'SHIFT_DETAIL_REQUEST_SUCCESS',
    SHIFT_DETAIL_REQUEST_ERROR: 'SHIFT_DETAIL_REQUEST_ERROR',

    UPDATE_SHIFT_REQUEST: 'UPDATE_SHIFT_REQUEST',
    UPDATE_SHIFT_REQUEST_SUCCESS: 'UPDATE_SHIFT_REQUEST_SUCCESS',
    UPDATE_SHIFT_REQUEST_ERROR: 'UPDATE_SHIFT_REQUEST_ERROR',
    UPDATE_SHIFT_REQUEST_STATUS: 'UPDATE_SHIFT_REQUEST_STATUS',

    ASSIGN_SHIFT_REQUEST: 'ASSIGN_SHIFT_REQUEST',
    ASSIGN_SHIFT_REQUEST_SUCCESS: 'ASSIGN_SHIFT_REQUEST_SUCCESS',
    ASSIGN_SHIFT_REQUEST_ERROR: 'ASSIGN_SHIFT_REQUEST_ERROR',
    ASSIGN_SHIFT_REQUEST_STATUS: 'ASSIGN_SHIFT_REQUEST_STATUS',

    REQUEST_SHIFT_REQUEST: 'REQUEST_SHIFT_REQUEST',
    REQUEST_SHIFT_REQUEST_SUCCESS: 'REQUEST_SHIFT_REQUEST_SUCCESS',
    REQUEST_SHIFT_REQUEST_ERROR: 'REQUEST_SHIFT_REQUEST_ERROR',
    REQUEST_SHIFT_REQUEST_STATUS: 'REQUEST_SHIFT_REQUEST_STATUS',

    SHIFT_REMOVE_EMPLOYEE_REQUEST: 'SHIFT_REMOVE_EMPLOYEE_REQUEST',
    SHIFT_REMOVE_EMPLOYEE_REQUEST_SUCCESS: 'SHIFT_REMOVE_EMPLOYEE_REQUEST_SUCCESS',
    SHIFT_REMOVE_EMPLOYEE_REQUEST_ERROR: 'SHIFT_REMOVE_EMPLOYEE_REQUEST_ERROR',
    SHIFT_REMOVE_EMPLOYEE_REQUEST_STATUS: 'SHIFT_REMOVE_EMPLOYEE_REQUEST_STATUS',

    DECLINE_REQUEST_SHIFT_REQUEST: 'DECLINE_REQUEST_SHIFT_REQUEST',
    DECLINE_REQUEST_SHIFT_REQUEST_SUCCESS: 'DECLINE_REQUEST_SHIFT_REQUEST_SUCCESS',
    DECLINE_REQUEST_SHIFT_REQUEST_ERROR: 'DECLINE_REQUEST_SHIFT_REQUEST_ERROR',
    DECLINE_REQUEST_SHIFT_REQUEST_STATUS: 'DECLINE_REQUEST_SHIFT_REQUEST_STATUS'
}
